<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-ai.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0">企業級一站式GenAI平台</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">企業級一站式GenAI平台</h2>
				<div style="margin-top: 48px; ">
						<p style="font-size: 18px">
							GenAI平台是面向企業私域數據的端到端生成式AI平台，支援全流程閉環應用（數據→訓練→部署→場景落地）。全棧私有化部署，支援本地數據中心、混合雲及信創雲環境，符合等保2.0/3.0及國密算法要求。
						</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心功能</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">多模型融合推理引擎</div>
									<div class="t2">
										支援國內外主流開源模型（如Llama 3、DeepSeek-R、Qwen）一鍵調用，兼容40+基礎大模型按需切換<br>
										異構算力調度：動態分配CPU/GPU資源，優化模型與芯片匹配策略，提升GPU利用率30%以上
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">多模型自由切換</div>
									<div class="t2">
										模型倉庫集成：預置Llama、Qwen、DeepSeek等主流開源模型，用戶可按需加載不同模型應對多樣化任務<br>
										離線全功能支援：所有模型推理、訓練、知識庫構建均可在斷網環境下完成，徹底擺脫雲端依賴
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">企業知識中樞</div>
									<div class="t2">
										私域知識庫構建：支援文檔/圖片/數據庫自動解析、向量化存儲與圖譜關聯，構建企業專屬知識網絡<br>
										RAG增強檢索：結合圖推理技術（Graph-enhanced RAG），解決複雜業務查詢的精準召回問題（如合同條款溯源、技術規範檢索）
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">零代碼應用工廠</div>
										<div class="t2">
											提供預置AI模板庫（如智能客服、報告生成、流程自動化），支援拖拽式工作流設計，無需編碼即可構建場景應用<br>
											智能體（Agent）編排：通過多智能體協同（Planning-Reflection-Collaboration）處理跨系統任務（如供應鏈異常預警、財務對賬）
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">全鏈路安全治理</div>
										<div class="t2">
											數據不出域：訓練/推理全程本地化，支援硬件級加密與敏感信息脫敏<br>
											合規護欄：內置內容過濾、審計日誌與權限管控，滿足金融、醫療等行業強合規要求
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/genai1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">應用場景</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/genai2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">智能決策支援</div>
										<div class="t2">
											融合業務數據與行業知識庫，生成市場趨勢分析、風險評估報告
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">流程自動化</div>
										<div class="t2">
											RPA+AI驅動訂單處理、發票核驗、合規審查，減少70%人工操作
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">客戶交互升級</div>
									<div class="t2">
										知識庫增強型客服機器人，支援多語言精準答疑與個性化推薦
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">生產優化</div>
									<div class="t2">
										工業設備維護輔助、供應鏈動態調度（如港口船舶靠泊效率提升25%）
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">內部知識管理</div>
										<div class="t2">
											員工助手一鍵檢索技術文檔、生成會議紀要，縮短信息獲取時間50%
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心優勢</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">信創全棧適配</div>
										<div class="t2">
											從芯片（鯤鵬/昇騰）到操作系統（麒麟/統信）全鏈路國產化，無縫對接稅務、金融等關鍵領域信創替代需求
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">TCO降低60%</div>
										<div class="t2">
											軟硬一體優化：通過MoE稀疏激活、FP8混合精度訓練，推理能耗降低40%
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">敏捷落地能力</div>
										<div class="t2">
											3天上線基礎場景：預置行業模板+自動化部署工具，快速響應業務需求
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">安全與效能兼得</div>
										<div class="t2">
											在保障數據主權前提下，實現業務洞察效率提升3倍
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/genai3.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
